import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Owl(props: PresetArtProps) {
  return (
    <PresetFrame background="#7c3aed" {...props}>
      <path d="M18 16 L27 24 H37 L46 16 V40 Q46 52 32 52 Q18 52 18 40 Z" fill="#ffffff" />
      <circle cx="26" cy="33" r="5.5" fill="#1f2937" />
      <circle cx="38" cy="33" r="5.5" fill="#1f2937" />
      <circle cx="26" cy="33" r="2" fill="#ffffff" />
      <circle cx="38" cy="33" r="2" fill="#ffffff" />
      <path d="M29 40 H35 L32 45 Z" fill="#f59e0b" />
    </PresetFrame>
  );
}
